import { Heart, Leaf, Shield } from "lucide-react";
import { FeaturesGrid } from "../shared/FeaturesGrid";

export const LifeFeatures = () => {
  const features = [
    {
      icon: Heart,
      title: "Personalized Service",
      description: "Customized solutions for your unique situation."
    },
    {
      icon: Leaf,
      title: "Flexible Options",
      description: "Adaptable coverage that grows with your needs."
    },
    {
      icon: Shield,
      title: "Reliable Protection",
      description: "Trusted coverage from top-rated providers."
    }
  ];

  return (
    <FeaturesGrid
      title="Life Insurance Expertise"
      description="Trust our experienced advisors to guide you through life's important insurance decisions."
      features={features}
    />
  );
};